<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <template-listing-base
        v-bind:title="resource('TemplateDraftListing_Listing_Title')"
        v-bind:list-title="resource('TemplateDraftListing_Listing_ListTitle')"
        v-bind:templates="templates"
        v-bind:can-search="true"
    >
        <template v-slot:template-listing-header>
            <i
                    class="fa fa-plus pull-right action-item"
                    aria-hidden="true"
                    v-if="canCreateTemplates"
                    @click="createTemplate()"
            ></i>
        </template>
        
        <template v-slot:template-listing-item="{template}">
            <template-draft-listing-item
                v-bind:class="{ selected: selectedTemplate === template }"
                v-bind:template="template"
                @template-selected="$emit('template-selected', template.Id)"
                @template-deleted="removeTemplate(template)"
            ></template-draft-listing-item>
        </template>
    </template-listing-base>
</template>

<script>
    import templateApi from '../../../../Api/template-manager';

    import templateStates from '../../template-states';

    import growlApi from '../../../../Util/growler';
    import resourceMixin from '../../../../Util/Mixins/resources';
    import guidMixin from '../../../../Util/Mixins/guid';
    import securityApi from '../../../../Util/security';
    
    import TemplateListingBase from './TemplateListingBase.vue';
    import TemplateDraftListingItem from './TemplateDraftListingItem.vue';
    
    export default {
        name: "template-draft-listing",
        components: {
            TemplateListingBase,
            TemplateDraftListingItem
        },
        mixins: [resourceMixin, guidMixin],
        created() {
            const vm = this;
            
            templateApi.getTemplateList(templateStates.draft)
                .then(
                    data => vm.templates = data,
                    err => growlApi.error(err)
                );
            
            templateApi.validatePermission(securityApi.PermissionGrantTypes.Write)
                .then(canWrite => vm.canCreateTemplates = canWrite);
        },
        methods: {
            selectTemplate(template){
                const vm = this;
                
                vm.selectedTemplate = template;
            },
            createTemplate() {
                const vm = this;
                window.location.href = `/Templates/${this.emptyGuid()}`
            },
            removeTemplate(template){
                const vm = this;
                
                //Can't splice without a proper index
                const idx = vm.templates.indexOf(template);
                if(idx !== -1){
                    vm.templates.splice(idx, 1);
                }
            }
        },
        data(){
            return {
                templates: [],
                selectedTemplate: null,
                canCreateTemplates: false
            }
        }
    };
</script>
